export const parseMetaData = (config: string) => {
  try {
    const metaConfig = JSON.parse(config);
    return metaConfig.file_meta
  } catch {
    return {};
  }
}